export const num = {
  likeCount: (n) => {
    if (!n) return 0
    if (n < 10000) return n
    return `${Number((n / 10000).toFixed(1))}万`
  },
}

export function formatVersion(versionStr = '') {
  const verStr = versionStr.split('.')

  //  补充到5个版本 ['11','2','3','001'] => ['11','2','3','001','']
  while (verStr.length < 5) verStr.push('')

  // 每个版本位置补充到4位  ['11','2','3',''] => ['0011','0002','0003','0000']
  const fillVerStr = verStr.map((v) => v.padStart(4, '0'))

  // 返回数字化的版本号 ['0011','0002','0003','0000'] => 11000200030000
  return parseInt(fillVerStr.join(''), 10)
}
